export default {
  Dashboard: 'Instrumententafel',
  eCommerce: 'eCommerce',
  Apps: 'Apps',
  Todo: 'Machen',
  Chat: 'Plaudern',
  Email: 'Email',
  Calendar: 'Kalender',
  FullCalendar: 'Calendrier completVollständiger Kalender',
  SimpleCalendar: 'Einfacher Kalender',
  Shop: 'Geschäft',
  ItemDetails: 'Artikeldetails',
  Cart: 'Wagen',
  WishList: 'Wunschzettel',
  Checkout: 'Auschecken',
  UI: 'UI',
  DataList: 'Datenliste',
  ListView: 'Listenansicht',
  ThumbView: 'Daumenansicht',
  Grid: 'Gitter',
  Vuexy: 'Vuexy',
  Vuesax: 'Vuesax',
  Tailwind: 'Tailwind',
  Colors: 'Farben',
  Card: 'Karte',
  Basic: 'Basic',
  Statistics: 'Statistiken',
  Analytics: 'Analytics',
  CardActions: 'Kartenaktionen',
  CardColors: 'Kartenfarben',
  Table: 'Tabelle',
  agGridTable: 'agGrid-Tabelle',
  Components: 'Komponenten',
  Alert: 'Warnen',
  Avatar: 'Benutzerbild',
  Badge: 'Abzeichen',
  Breadcrumb: 'Breadcrumb',
  Button: 'Taste',
  ButtonGroup: 'Schaltflächengruppe',
  Chip: 'Chip',
  Collapse: 'Zusammenbruch',
  Dialogs: 'Dialoge',
  Divider: 'Teiler',
  DropDown: 'Dropdown-Liste',
  List: 'Liste',
  Loading: 'Wird geladen',
  Navbar: 'Navbar',
  Notifications: 'Benachrichtigungen',
  Pagination: 'Seitennummerierung',
  Popup: 'Pop-up',
  Progress: 'Fortschritt',
  Sidebar: 'Seitenleiste',
  Slider: 'Schieberegler',
  Tabs: 'Tabs',
  Tooltip: 'QuickInfo',
  Upload: 'Hochladen',
  FormsAndTable: 'Formulare und Tabelle',
  FormElements: 'Formularelemente',
  Select: 'Wählen',
  Switch: 'Schalter',
  Checkbox: 'Ankreuzfeld',
  Radio: 'Radio',
  Input: 'Eingang',
  NumberInput: 'Nummer eingeben',
  Textarea: 'Textbereich',
  FormLayouts: 'Formularlayouts',
  FormWizard: 'Formzauberer',
  FormValidation: 'Formularvalidierung',
  FormInputGroup: 'Formulareingabegruppe',
  Pages: 'Seiten',
  Authentication: 'Authentifizierung',
  Login: 'Anmeldung',
  Register: 'Registrieren',
  ForgotPassword: 'Passwort vergessen',
  ResetPassword: 'Passwort zurücksetzen',
  LockScreen: 'Bildschirm sperren',
  Miscellaneous: 'Verschiedenes',
  ComingSoon: 'Demnächst',
  Error: 'Error',
  404: '404',
  500: '500',
  NotAuthorized: 'Nicht berechtigt',
  Maintenance: 'Instandhaltung',
  Profile: 'Profil',
  User: 'Benutzer',
  View: 'Aussicht',
  Edit: 'Bearbeiten',
  UserSettings: 'Benutzereinstellungen',
  Invoice: 'Rechnung',
  FAQ: 'FAQ',
  Search: 'Suche',
  KnowledgeBase: 'Wissensbasis',
  ChartsAndMaps: 'Diagramme und Karten',
  Charts: 'Diagramme',
  ApexCharts: 'Apex Charts',
  chartjs: 'chartjs',
  echarts: 'echarts',
  chartist: 'chartist',
  GoogleMap: 'Google Karte',
  Extensions: 'Erweiterungen',
  QuillEditor: 'Quill-Editor',
  DragAndDrop: 'Ziehen und loslassen',
  Datepicker: 'Datumsauswahl',
  DatetimePicker: 'Datum / Uhrzeit-Auswahl',
  AccessControl: 'Zugangskontrolle',
  I18n: 'I18n',
  Carousel: 'Karussell',
  Clipboard: 'Zwischenablage',
  ContextMenu: 'Kontextmenü',
  StarRatings: 'Sterne Bewertungen',
  Autocomplete: 'Autovervollständigung',
  Tree: 'Baum',
  // "Import/Export": 'Einführen/Export',
  Import: 'Einführen',
  Export: 'Export',
  ExportSelected: 'Auswahl exportieren',
  Others: 'Andere',
  MenuLevels: 'Menüebenen',
  MenuLevel2p1: 'Menüebene 2.1',
  MenuLevel2p2: 'Menüebene 2.2',
  MenuLevel3p1: 'Menüebene 3.1',
  MenuLevel3p2: 'Menüebene 3.2',
  DisabledMenu: 'Deaktiviertes Menü',
  Support: 'Unterstützung',
  Documentation: 'Dokumentation',
  RaiseSupport: 'Unterstützung erheben',
  demoTitle: 'Kartentitel',
  demoText: 'Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.'
};
